import React, { useContext, useState } from "react";
import "./Communication_preferences.css";
import Heading_banner_section from "../../common_components/heading_banner/Heading_banner_section";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Purple_Btn from "../../common_components/common_btn/purple_btn/Purple_Btn";
import { Context } from "../../../utils/context";
import LogoutModal from "../../../components/Common-Component/Commonmodal/LogoutModal/LogoutModal";

function Communication_preferences() {
  const breadcrumbItems = [
    { label: "HOME", link: "/luxury/home" },
    { label: "YOUR ACCOUNT", link: "/luxury/account" },
    { label: "Communication Preferences" },
  ];

  // ✅ Interests Array
  const interestsList = [
    {
      id: 1,
      name: "ODA Lapel Pin",
      img: "/assest/luxury_images/gifts/img1.png",
    },
    {
      id: 2,
      name: "ODA Lapel Pin",
      img: "/assest/luxury_images/gifts/img1.png",
    },
    {
      id: 3,
      name: "ODA Lapel Pin",
      img: "/assest/luxury_images/gifts/img1.png",
    },
    {
      id: 4,
      name: "ODA Lapel Pin",
      img: "/assest/luxury_images/gifts/img1.png",
    },
    {
      id: 5,
      name: "ODA Lapel Pin",
      img: "/assest/luxury_images/gifts/img1.png",
    },
    {
      id: 6,
      name: "ODA Lapel Pin",
      img: "/assest/luxury_images/gifts/img1.png",
    },
    {
      id: 7,
      name: "ODA Lapel Pin",
      img: "/assest/luxury_images/gifts/img1.png",
    },
    {
      id: 8,
      name: "ODA Lapel Pin",
      img: "/assest/luxury_images/gifts/img1.png",
    },
    {
      id: 9,
      name: "ODA Lapel Pin",
      img: "/assest/luxury_images/gifts/img1.png",
    },
  ];

  const { userdata, setSignin } = useContext(Context);
  const [logoutshow, setLogoutshow] = useState(false);

  return (
    <>
      <section className="All_Orders Communication_preferences">
        <Heading_banner_section
          headingText={`${userdata?.first_name} ${userdata?.last_name}`}
          breadcrumbItems={breadcrumbItems}
        />

        <div className="custom_container">
          <div className="row justify-content-center">
            <div className="col-md-12">
              <div className="all_order_section_holder">
                <div className="text_holder">
                  <h3
                    className="sign_out_text"
                    onClick={() => setLogoutshow(true)}
                  >
                    <FontAwesomeIcon
                      className="me-3"
                      icon={faArrowRightFromBracket}
                    />
                    SIGN OUT
                  </h3>
                </div>

                <div className="heading_tab_content_holder">
                  <div className="heading_holder">
                    <h1>REGARDING GENERAL COMMUNICATION</h1>
                    <p>
                      Stay up to date with the latest information about our
                      products, services and promotions. We may tailor our
                      communications according to your location and purchases.
                    </p>
                  </div>

                  <div className="row">
                    <div className="col-md-4 col-sm-4 col-6">
                      <Form.Group className="mb-3">
                        <Form.Check type="checkbox" label="Email" />
                      </Form.Group>
                    </div>

                    <div className="col-md-4 col-sm-4 col-6">
                      <Form.Group className="mb-3">
                        <Form.Check type="checkbox" label="SMS" />
                      </Form.Group>
                    </div>

                    <div className="col-md-4 col-sm-4 col-6">
                      <Form.Group className="mb-3">
                        <Form.Check type="checkbox" label="Phone" />
                      </Form.Group>
                    </div>
                  </div>
                </div>

                <div className="your_intrest_holder">
                  <div className="intrest_heading_holder">
                    <h1>YOUR INTERESTS</h1>
                    <p>
                      As well as general communications about Coinzkart, you can
                      tell us what you love and we'll personalise what we send
                      according to your interests.
                    </p>
                  </div>

                  <div className="instreast_list_holder">
                    <div className="row">
                      {interestsList.map((item) => (
                        <div className="col-md-4 col-sm-6" key={item.id}>
                          <Form.Group className="mb-3">
                            <div className="list_text_holder">
                              <Form.Check type="checkbox" />
                              <div className="img_holder">
                                <div>
                                  <img
                                    src={item.img}
                                    alt="product img"
                                    className="product_img"
                                  />
                                </div>
                              </div>
                              <p>{item.name}</p>
                            </div>
                          </Form.Group>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="btn_holder">
                    <Purple_Btn btnText={"Save Prefrences"} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <LogoutModal
          show={logoutshow}
          onHide={() => setLogoutshow(false)}
          text="Are you sure you want to log out?"
          setSignin={setSignin}
        />
      </section>
    </>
  );
}

export default Communication_preferences;
